<template>
  <ul class="menu mxr-declination">
    <template v-if="product && product.productInfo">
      <li @click="getProduct(declinaison.modelId)" :key="index" v-for="(declinaison, index) in product.productInfo.declinations">
        <img :src="`http://decathlon.fr/${declinaison.imgUrl}`" alt="" width="36">
      </li>
    </template>
  </ul>
</template>

<script>
  import utils from '../utils';

  export default {
    name: 'product-declination',
    props: ['product'],
    data() {
      return {
        selectedColor: [],
      };
    },
    methods: {
      getProduct(id) {
        utils.fetchProduct(id, (data) => {
          this.selectedColor = data;
          this.$store.commit('selectedColor', [this.selectedColor, this.product.productInfo.productId]);
        });
      },
    },
    updated() {
      this.$store.commit('selectedColor', [this.product, this.product.productInfo.productId]);
    },
  };
</script>

<style lang="scss">
  .mxr-declination {
    li {
      margin: rem-calc(0 10);
      cursor: pointer;
      img {
        transition: transform .2s ease;
      }
      &:hover {
        img {
          transform: scale(1.1);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ProductDeclination.vue?b39f5bb4